import React from "react";
import Heading from "../ui/Heading";
import { Container } from "react-bootstrap";
import InstaIframe from "../../../InstaIframe";

const Insta = () => {
  return (
    <section className="insta-section section-space pb-0">
      <Container fluid className="showcase-container">
        <Heading>
          <h2>Social Media</h2>
          <p>
            Follow us on Instagram{" "}
            <a
              href="https://www.instagram.com/belgium_webnet/"
              className="text-dark"
              target="_blank"
              rel="noreferrer"
            >
              <strong>@belgium_webnet</strong>
            </a>
          </p>
        </Heading>
      </Container>
      <InstaIframe />
    </section>
  );
};

export default Insta;
